import { useEffect, useState } from 'react';
import productTypes from '@general/productTypes';
import useCartFromAPI from '@hooks/apiLegacy/useCartFromAPI';
import useEventCompanyRosterFromAPI from '@hooks/apiLegacy/useEventCompanyRosterFromAPI';
import useViewer from '@hooks/useViewer';

export const reasonsForExclusion = {
    ALREADY_IN_CART: 'in cart',
    ALREADY_REGISTERED: 'registered',
};

const useMembersIneligibleForEventRegistration = ({ eventCode }) => {
    const [membersIneligibleForEventRegistration, setMembersIneligibleForEventRegistration] = useState();
    const { viewer } = useViewer();
    const { cart } = useCartFromAPI({ viewerId: viewer?.recordId });
    const { eventCompanyRoster } = useEventCompanyRosterFromAPI({
        eventCode,
        companyId: viewer?.company?.recordId || viewer?.deferredCompany?.recordId,
    });

    useEffect(() => {
        if (viewer && !viewer.company && !viewer.deferredCompany) {
            setMembersIneligibleForEventRegistration([]);
            return;
        }

        if (!cart || !eventCompanyRoster) {
            return;
        }

        const memberIdsInCart = cart.items
            .filter(item => item.product_type === productTypes.EVENT && item.meta_info?.event_code === eventCode)
            .map(item => ({
                id: item.member_id,
                reason: reasonsForExclusion.ALREADY_IN_CART,
            }));

        const memberIdsRegistered = eventCompanyRoster.map(member => ({
            id: member.id,
            reason: reasonsForExclusion.ALREADY_REGISTERED,
        }));

        setMembersIneligibleForEventRegistration([...memberIdsInCart, ...memberIdsRegistered]);
    }, [viewer, cart, eventCode, eventCompanyRoster]);

    return { membersIneligibleForEventRegistration };
};

export default useMembersIneligibleForEventRegistration;
